import React, { Suspense } from "react";
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import Routes from "./Routes";
import { AuthProvider } from './contexts/AuthContext';

function App() {
  return (
    <I18nextProvider i18n={i18n}>
      <AuthProvider>
        <Suspense fallback={
          <div className="flex items-center justify-center min-h-screen">
            <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-primary"></div>
          </div>
        }>
          <Routes />
        </Suspense>
      </AuthProvider>
    </I18nextProvider>
  );
}

export default App;